var map = {
	"./au-ac.svg": 48,
	"./au-act.svg": 49,
	"./au-ct.svg": 50,
	"./au-ns.svg": 51,
	"./au-nsw.svg": 52,
	"./au-nt.svg": 53,
	"./au-ql.svg": 54,
	"./au-qld.svg": 55,
	"./au-sa.svg": 31,
	"./au-ta.svg": 56,
	"./au-ts.svg": 57,
	"./au-vi.svg": 58,
	"./au-vic.svg": 59,
	"./au-wa.svg": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;